import { IInitialState } from "../Interfaces";

export const initialState: IInitialState = {
    closureCodeList: {
        data: [],
        isLoading: false
    },
    drawerDetails: {
        isVisible: false,
        codeId: -1,
        action: ""
    },
    closureCodeHistory: {
        data: [],
        isLoading: false
    }
};
  